// Packages Import
import { memo } from "react";
import { Box, Grid, Button, Typography } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";

// Project Component
import { Code4ReportAction } from "../../../store/Code4Report/Code4Report-slice";

const Code4ReportInfo = (props) => {
	const dispatch = useDispatch();

	const prevFilteredData = useSelector((state) => state.code4ReportState.prevFilteredData);

	const selectedRows = useSelector((state) => state.code4ReportState.selectedRows);
	const projectTableData = useSelector((state) => state.code4ReportState.PROJECT_INFO_TABLE);

	const userInfo = {
		org: useSelector((state) => state.authenticationState.User_Assigned_Orgs),
	};

	const isInOrg = userInfo.org.allOrg.includes(prevFilteredData.userOrg);

	const handleShowCode4PartsClicked = () => {
		let bom_ppn = [];

		selectedRows.forEach((index) => {
			bom_ppn.push(projectTableData[index].bom);
		});
		props.fetchCode4Parts(bom_ppn);
		dispatch(Code4ReportAction.clearEditedTable());
		dispatch(Code4ReportAction.setFetchedbom_ppn(bom_ppn));
		dispatch(Code4ReportAction.setEditingTable(false));
	};

	// useEffect(() => {
	// 	if (location.pathname === "/Code4Report" && projectUID !== "-") {
	// 		handleDetailsListUpdate(undefined, "all");
	// 	}
	// }, [location, projectUID]);
	return (
		<Box>
			<Grid container direction="row" justifyContent="space-between" alignItems="flex-start" spacing={1} wrap="wrap" sx={{ my: 1.5 }}>
				<Grid item xl={8} lg={8} md={8} sm={8} xs={12} p={1}>
					<Grid container direction="row" spacing={1} wrap="wrap">
						<Grid item xl={12} lg={12} md={12} sm={12} xs={12} textAlign="center">
							<Grid
								container
								direction="row"
								spacing={0.5}
								wrap="wrap"
								sx={{
									mb: 1.5,
								}}
							>
								{/* <Grid item xl={4.7} lg={4.7} md={4.7} sm={12} xs={12} textAlign="center">
									<Typography variant="h6">{projectInfoData[projectIndex].title || "-"}</Typography>
									<Typography variant="caption">Projects Responsibility Info</Typography>
								</Grid> */}
							</Grid>

							<Grid item xl={3} lg={3} md={6} sm={12} xs={12} textAlign="center">
								<Button variant="contained" sx={{ px: 1, width: "100%" }} disabled={selectedRows.length === 0} onClick={handleShowCode4PartsClicked}>
									Show code 4 parts
								</Button>
							</Grid>
							{isInOrg ? undefined : (
								<Grid item xl={12} lg={12} md={12} sm={12} xs={12} container justify="center" alignItems="center">
									<Typography variant="subtitle" color="red" mt={2}>
										User is not within {prevFilteredData.userOrg} to edit this information
									</Typography>
								</Grid>
							)}
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Box>
	);
};

export default memo(Code4ReportInfo);
